module.exports = __webpack_public_path__ + "static/media/carIcon.dd1903eb.png";